import { Tabs } from "@/components/ui/tabs";
import { cn } from "@/utils/utils";

export interface SheetTabsProps {
  children?: React.ReactNode;
  defaultValue?: string;
  className?: string;
  value?: string;
  onValueChange?: (value: string) => void;
}

export const SheetTabsContainer = ({
  children,
  defaultValue,
  className,
  onValueChange,
  value,
}: SheetTabsProps) => {
  return (
    <Tabs
      value={value}
      onValueChange={onValueChange}
      defaultValue={defaultValue}
      className={cn("flex flex-1 flex-col overflow-hidden", className)}
    >
      {children}
    </Tabs>
  );
};
